import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { MAX_STEP_LABEL_LENGTH } from '../../../../features/step/step-model.ts';
import Button from '../svelte-button.svelte';

var root = $.from_html(`<section data-part="step-head" class="svelte-14p5wwo"><div data-part="step-title-row" class="svelte-14p5wwo"><button type="button" class="step-drag-handle svelte-14p5wwo" data-step-drag-handle="true">drag</button> <input type="text" class="step-title-input svelte-14p5wwo"/></div> <div data-part="step-actions" class="svelte-14p5wwo"><!> <!> <!></div></section>`);

const $$css = {
	hash: 'svelte-14p5wwo',
	code: '[data-part="step-head"].svelte-14p5wwo {display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;grid-column:1 / -1;gap:8px;}[data-part="step-title-row"].svelte-14p5wwo {display:flex;align-items:center;gap:8px;min-width:0;}.step-drag-handle.svelte-14p5wwo {padding:4px 7px;min-width:0;font-size:10px;letter-spacing:0.08em;text-transform:uppercase;color:var(--color-muted);cursor:grab;background:transparent;border:1px solid var(--color-line);border-radius:8px;}.step-drag-handle.svelte-14p5wwo:active {cursor:grabbing;}.step-title-input.svelte-14p5wwo {min-width:0;width:min(180px, 38vw);color:var(--color-text-strong);font-size:12px;font-weight:700;padding:4px 6px;border:1px solid transparent;border-radius:8px;background:transparent;}.step-title-input.svelte-14p5wwo:hover {border-color:color-mix(in srgb, var(--color-line), var(--color-accent) 32%);background:color-mix(in srgb, var(--color-panel), var(--color-bg) 10%);}.step-title-input.svelte-14p5wwo:focus {outline:none;border-color:var(--color-accent);background:color-mix(in srgb, var(--color-panel), var(--color-bg) 6%);}[data-part="step-actions"].svelte-14p5wwo {display:inline-flex;align-items:center;justify-content:flex-end;gap:6px;flex-wrap:wrap;}'
};

export default function Svelte_step_header($$anchor, $$props) {
	$.push($$props, true);
	$.append_styles($$anchor, $$css);

	const step = $.prop($$props, 'step', 7),
		stepIndex = $.prop($$props, 'stepIndex', 7),
		tr = $.prop($$props, 'tr', 7),
		onCaptureScroll = $.prop($$props, 'onCaptureScroll', 7, () => undefined),
		onStepMuteChange = $.prop($$props, 'onStepMuteChange', 7, () => undefined),
		onDuplicateStep = $.prop($$props, 'onDuplicateStep', 7, () => undefined),
		onRemoveStep = $.prop($$props, 'onRemoveStep', 7, () => undefined),
		onStepLabelChange = $.prop($$props, 'onStepLabelChange', 7, () => undefined),
		onStatus = $.prop($$props, 'onStatus', 7, () => undefined);

	function resolveStepLabel() {
		const customLabel = typeof step().label === 'string' ? step().label.trim() : '';

		return customLabel.length > 0 ? customLabel : `Step ${stepIndex() + 1}`;
	}

	function captureBeforeAction() {
		onCaptureScroll()();

		return true;
	}

	function commitStepLabel(inputElement) {
		if (!inputElement) {
			onStatus()(tr()('pipeline.status.stepLabelInputMissing'), 'error');

			return;
		}

		const rawValue = inputElement.value;

		if (typeof rawValue !== 'string') {
			onStatus()(tr()('pipeline.status.stepLabelInvalidValue'), 'error');
			inputElement.value = resolveStepLabel();

			return;
		}

		const trimmed = rawValue.trim();

		if (trimmed.length > MAX_STEP_LABEL_LENGTH) {
			onStatus()(tr()('pipeline.status.stepLabelTooLong', { max: MAX_STEP_LABEL_LENGTH }), 'error');
			inputElement.value = trimmed.slice(0, MAX_STEP_LABEL_LENGTH);

			return;
		}

		onCaptureScroll()();
		onStepLabelChange()(step().id, trimmed.length > 0 ? trimmed : null);
		inputElement.value = trimmed.length > 0 ? trimmed : resolveStepLabel();
	}

	var $$exports = {
		get step() {
			return step();
		},

		set step($$value) {
			step($$value);
			$.flush();
		},

		get stepIndex() {
			return stepIndex();
		},

		set stepIndex($$value) {
			stepIndex($$value);
			$.flush();
		},

		get tr() {
			return tr();
		},

		set tr($$value) {
			tr($$value);
			$.flush();
		},

		get onCaptureScroll() {
			return onCaptureScroll();
		},

		set onCaptureScroll($$value = () => undefined) {
			onCaptureScroll($$value);
			$.flush();
		},

		get onStepMuteChange() {
			return onStepMuteChange();
		},

		set onStepMuteChange($$value = () => undefined) {
			onStepMuteChange($$value);
			$.flush();
		},

		get onDuplicateStep() {
			return onDuplicateStep();
		},

		set onDuplicateStep($$value = () => undefined) {
			onDuplicateStep($$value);
			$.flush();
		},

		get onRemoveStep() {
			return onRemoveStep();
		},

		set onRemoveStep($$value = () => undefined) {
			onRemoveStep($$value);
			$.flush();
		},

		get onStepLabelChange() {
			return onStepLabelChange();
		},

		set onStepLabelChange($$value = () => undefined) {
			onStepLabelChange($$value);
			$.flush();
		},

		get onStatus() {
			return onStatus();
		},

		set onStatus($$value = () => undefined) {
			onStatus($$value);
			$.flush();
		}
	};

	var section = root();
	var div = $.child(section);
	var button = $.child(div);

	$.set_attribute(button, 'draggable', true);

	var input_1 = $.sibling(button, 2);

	$.remove_input_defaults(input_1);
	$.reset(div);

	var div_1 = $.sibling(div, 2);
	var node = $.child(div_1);

	{
		let $0 = $.derived(() => step().muted ? 'true' : 'false');

		Button(node, {
			variant: 'small',
			get active() {
				return step().muted;
			},

			get ariaPressed() {
				return $.get($0);
			},
			blurOnPress: true,
			handleMouseDown: (event) => {
				onCaptureScroll()();
				event.preventDefault();
			},

			handlePress: () => {
				if (!captureBeforeAction()) return;

				onStepMuteChange()(step().id, !step().muted);
			},

			children: ($$anchor, $$slotProps) => {
				$.next();

				var text = $.text();

				$.template_effect(($0) => $.set_text(text, $0), [
					() => step().muted
						? tr()('pipeline.step.unmute')
						: tr()('pipeline.step.mute')
				]);

				$.append($$anchor, text);
			},
			$$slots: { default: true }
		});
	}

	var node_1 = $.sibling(node, 2);

	Button(node_1, {
		variant: 'small',
		blurOnPress: true,
		handleMouseDown: (event) => {
			onCaptureScroll()();
			event.preventDefault();
		},

		handlePress: () => {
			if (!captureBeforeAction()) return;

			onDuplicateStep()(step().id);
		},

		children: ($$anchor, $$slotProps) => {
			$.next();

			var text_1 = $.text();

			$.template_effect(($0) => $.set_text(text_1, $0), [() => tr()('pipeline.step.duplicate')]);
			$.append($$anchor, text_1);
		},
		$$slots: { default: true }
	});

	var node_2 = $.sibling(node_1, 2);

	Button(node_2, {
		variant: ["destructive", "small"],
		blurOnPress: true,
		handleMouseDown: (event) => {
			onCaptureScroll()();
			event.preventDefault();
		},

		handlePress: () => {
			if (!captureBeforeAction()) return;

			onRemoveStep()(step().id);
		},

		children: ($$anchor, $$slotProps) => {
			$.next();

			var text_2 = $.text();

			$.template_effect(($0) => $.set_text(text_2, $0), [() => tr()('pipeline.step.remove')]);
			$.append($$anchor, text_2);
		},
		$$slots: { default: true }
	});

	$.reset(div_1);
	$.reset(section);

	$.template_effect(
		($0, $1, $2) => {
			$.set_attribute(button, 'data-step-id', step().id);
			$.set_attribute(button, 'title', $0);
			$.set_value(input_1, $1);
			$.set_attribute(input_1, 'maxlength', MAX_STEP_LABEL_LENGTH);
			$.set_attribute(input_1, 'aria-label', $2);
		},
		[
			() => tr()('pipeline.step.dragMove'),
			() => resolveStepLabel(),
			() => tr()('pipeline.step.titleAria', { index: stepIndex() + 1 })
		]
	);

	$.event('blur', input_1, (event) => commitStepLabel(event.currentTarget));

	$.delegated('keydown', input_1, (event) => {
		const input = event.currentTarget;

		if (!input) {
			onStatus()(tr()('pipeline.status.stepLabelInputMissing'), 'error');

			return;
		}

		if (event.key === 'Enter') {
			event.preventDefault();
			input.blur();

			return;
		}

		if (event.key === 'Escape') {
			event.preventDefault();
			input.value = resolveStepLabel();
			input.blur();
		}
	});

	$.append($$anchor, section);

	return $.pop($$exports);
}

$.delegate(['keydown']);

$.create_custom_element(
	Svelte_step_header,
	{
		step: {},
		stepIndex: {},
		tr: {},
		onCaptureScroll: {},
		onStepMuteChange: {},
		onDuplicateStep: {},
		onRemoveStep: {},
		onStepLabelChange: {},
		onStatus: {}
	},
	[],
	[],
	{ mode: 'open' }
);